import { render, staticRenderFns } from "./pie-revenue-witel.vue?vue&type=template&id=9b87af70&scoped=true&"
import script from "./pie-revenue-witel.vue?vue&type=script&lang=js&"
export * from "./pie-revenue-witel.vue?vue&type=script&lang=js&"
import style0 from "./pie-revenue-witel.vue?vue&type=style&index=0&id=9b87af70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87af70",
  null
  
)

export default component.exports